<template>
  <div
    class="inner"
    :class="{ swiping: isSwiping }"
    :style="{ transform: `translateY(${translateY}px)` }"
  >
    <SwipeWrapper
      @pan-start="handleSwipeDownStart"
      @pan-move="handleSwipeMove"
      @pan-end="handleSwipeDownEnd"
    >
      <div class="swipe"></div>
    </SwipeWrapper>
    <div class="lines">
      <div class="line _active" />
      <div class="line _active" />
      <div class="line _active" />
      <div class="line _active" />
    </div>
    <div class="main-block">
      <h2>Во сколько начинаем?</h2>
      <p class="message">
        Выберите удобный час — мы покажем все доступные варианты с точностью до
        10 минут.
      </p>
      <TimeSlots
        v-if="isLoaded"
        :timeSlots="timeSlots"
        :currentHour="currentHour"
        :currentMinute="currentMinute"
        @isDateSlot="$emit('isDateSlot', $event)"
        @updateHour="currentHour = $event"
        @updateMinute="currentMinute = $event"
        class="timeSlots"
      />
    </div>
    <div class="buttons">
      <div
        class="prev-button"
        v-if="screenWidth === 'mobile'"
        @click="onPrevClickHandler"
      >
        <IconArrowButton color="#F18E35" />
      </div>
      <VButton v-else outline @click="onPrevClickHandler" class="button">
        Назад
      </VButton>
      <VButton
        :disabled="currentMinute > 7"
        @click="onNextClickHandler"
        class="button"
      >
        <template v-if="screenWidth === 'mobile'" #rightAddon>
          <IconArrowButton color="#ffffff" />
        </template>
        <template #default>Далее</template>
      </VButton>
    </div>
    <IconPopupCross
      v-if="screenWidth !== 'mobile'"
      class="modal-cross"
      @click="closeModal"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import IconPopupCross from "@/components/icons/IconPopupCross.vue";
import TimeSlots from "@/components/pages/w/TimeSlots.vue";
import IconArrowButton from "@/components/icons/IconArrowButton.vue";
import SwipeWrapper from "@/components/ui/SwipeWrapper.vue";

const store = useStore();

const screenWidth = computed(() => {
  return store.getters.screenType;
});
</script>

<script>
import VButton from "@/components/ui/VButton.vue";
import FilterDurationModal from "@/components/modals/mapCateringFilter/FilterDurationModal.vue";
import { getTimeZone } from "@/assets/js/utils/helpers";
export default {
  name: "FilterTimeModal",

  components: {
    VButton,
  },

  data() {
    return {
      currentHour: "00-00",
      currentMinute: 0,
      timeSlots: {
        "2024-7-25": {
          "00-00": [1, 1, 1, 1, 1, 1],
          "01-00": [1, 1, 1, 1, 1, 1],
          "02-00": [1, 1, 1, 1, 1, 1],
          "03-00": [1, 1, 1, 1, 1, 1],
          "04-00": [1, 1, 1, 1, 1, 1],
          "05-00": [1, 1, 1, 1, 1, 1],
          "06-00": [1, 1, 1, 1, 1, 1],
          "07-00": [1, 1, 1, 1, 1, 1],
          "08-00": [1, 1, 1, 1, 1, 1],
          "09-00": [1, 1, 1, 1, 1, 1],
          "10-00": [1, 1, 1, 1, 1, 1],
          "11-00": [1, 1, 1, 1, 1, 1],
          "12-00": [1, 1, 1, 1, 1, 1],
          "13-00": [1, 1, 1, 1, 1, 1],
          "14-00": [1, 1, 1, 1, 1, 1],
          "15-00": [1, 1, 1, 1, 1, 1],
          "16-00": [1, 1, 1, 1, 1, 1],
          "17-00": [1, 1, 1, 1, 1, 1],
          "18-00": [1, 1, 1, 1, 1, 1],
          "19-00": [1, 1, 1, 1, 1, 1],
          "20-00": [1, 1, 1, 1, 1, 1],
          "21-00": [1, 1, 1, 1, 1, 1],
          "22-00": [1, 1, 1, 1, 1, 1],
          "23-00": [1, 1, 1, 1, 1, 1],
        },
      },
      isLoaded: false,
      translateY: 0,
      isSwiping: false,
      threshold: 100,
    };
  },

  methods: {
    closeModal() {
      if (this.screenWidth === "mobile") {
        this.$store.dispatch("closeMobileModal");
      } else {
        this.$store.dispatch("closeModal");
      }
    },
    onPrevClickHandler() {
      if (this.screenWidth === "mobile") {
        this.$store.dispatch("openMobileModal", {
          value: {
            component: FilterDurationModal,
            props: {},
          },
        });
      } else {
        this.$store.dispatch("openModal", {
          value: {
            component: FilterDurationModal,
            props: {},
          },
        });
      }
    },
    async onNextClickHandler() {
      this.$store.commit({
        type: "setFilterTime",
        value: {
          hours: this.currentHour.slice(0, 2),
          minutes: this.currentMinute * 10,
        },
      });
      this.$store.dispatch("filterRestaurantsForBooking");
      if (this.screenWidth === "mobile") {
        this.$store.dispatch("closeMobileModal");
      } else {
        this.$store.dispatch("closeModal");
      }
    },
    handleSwipeDownStart() {
      this.isSwiping = true;
    },
    handleSwipeDownEnd() {
      if (this.translateY > this.threshold) {
        this.closeModal();
      } else {
        this.translateY = 0;
        this.isSwiping = false;
      }
    },
    handleSwipeMove(event) {
      if (event.deltaY > 0) {
        this.translateY = event.deltaY;
      }
    },
  },

  watch: {
    currentVisitorsCount(val) {
      this.$emit("changeVisitorsCount", val);
    },
  },

  mounted() {
    const date = new Date();

    const cityTime = new Date(
      date.toLocaleString("en-US", { timeZone: getTimeZone(this.city.city) })
    );

    let hours = cityTime.getHours();
    let minutes = cityTime.getMinutes();

    const roundedMinutes = Math.ceil(minutes / 10) * 10;

    if (roundedMinutes === 60) {
      minutes = 0;
      hours = (hours + 1) % 24;
    } else {
      minutes = roundedMinutes;
    }

    if (minutes < 10) {
      minutes = "0" + minutes;
    }

    if (minutes < 1) {
      minutes = "00";
    }

    if (hours < 10) {
      hours = "0" + hours;
    }

    this.currentHour = `${
      this.$store.state.clientRestaurants.filter.time?.hours || hours
    }-00`;
    this.currentMinute = this.$store.state.clientRestaurants.filter.time
      ?.minutes
      ? this.$store.state.clientRestaurants.filter.time.minutes / 10
      : minutes;

    if (this.$store.state.clientRestaurants.filter.date) {
      const filterDay = new Date(
        this.$store.state.clientRestaurants.filter.date
      );

      if (filterDay > cityTime) {
        this.currentHour = `${
          this.$store.state.clientRestaurants.filter.time?.hours || "17"
        }-00`;
        this.currentMinute = this.$store.state.clientRestaurants.filter.time
          ?.minutes
          ? this.$store.state.clientRestaurants.filter.time.minutes / 10
          : 0;
        this.isLoaded = true;

        return;
      }
    }

    let cutoffTime = cityTime.getHours() * 60 + cityTime.getMinutes();

    Object.keys(this.timeSlots["2024-7-25"]).forEach((time) => {
      const [hour, minute] = time.split("-").map(Number);
      const totalMinutes = hour * 60 + minute;

      if (totalMinutes < cutoffTime) {
        this.timeSlots["2024-7-25"][time] = this.timeSlots["2024-7-25"][
          time
        ].map((slot, index) => {
          return hour * 60 + index * 10 <= cutoffTime ? 2 : 1;
        });
      }
    });

    this.isLoaded = true;
  },

  computed: {
    screenWidth() {
      return this.$store.getters.screenType;
    },
    city() {
      return this.$store.state.general.city;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  margin: 32px 0 0;
}

.main-block {
  padding-bottom: 66px;

  @include mobile {
    padding-bottom: 60px;
    margin: 0 auto;
  }
}

.message {
  max-width: 528px;
  margin-top: 16px;
  margin-bottom: 32px;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #858585;

  @include mobile {
    margin-top: 0;
    margin-bottom: 32px;
  }
}

.buttons {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  width: 100%;
  gap: 16px;

  @include mobile {
    margin-top: auto;
  }
}

.button {
  height: 40px;
  width: 120px;
  padding: 9px 38px;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;

  @include mobile {
    width: 100%;
    border-radius: 100px;

    &:first-child {
      margin-bottom: 16px;
    }
  }
}
</style>

<style lang="scss" scoped>
.inner {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 776px;
  width: 640px;
  max-width: 640px;
  margin: auto;
  padding: 32px 56px 40px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  @media screen and (max-width: 841px) {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    box-shadow: 0 -2px 10px 0 #0000000d;
    border-radius: 20px 20px 0 0;
    padding: 40px 16px 24px 16px;
    min-height: 632px;
    max-height: 632px;
    height: 632px;
  }

  &.swiping {
    transition: none;
  }
}

h2 {
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;

  @include mobile {
    margin-bottom: 16px;
  }
}

.modal-cross {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

.timers {
  max-width: 776px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  > div {
    width: calc(50% - 8px);
  }
}

.lines {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 64px;
  gap: 10px;

  @include mobile {
    width: 100%;
    height: 8px;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 32px;
    padding: 0 4px;
    border-radius: 8px;
    background-color: white;
  }
}

.line {
  width: 122px;
  height: 8px;
  border-radius: 8px;
  background-color: #adadad;

  @include mobile {
    width: calc(25% - 4px);
    border-radius: 8px;
  }

  &._active {
    background-color: #f18e35;
    cursor: pointer;
  }
}

.prev-button {
  display: flex;
  flex: 0 0 auto;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #f18e35;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
    transform: rotate(180deg);
  }
}

.timeSlots {
  :deep(.hours-wrapper) {
    height: 288px;

    @include mobile {
      height: 272px;
    }
  }
}

.swipe {
  display: none;

  @include mobile {
    display: block;
    position: absolute;
    width: 100%;
    height: 20px;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 16px 16px 0 0;
    background-color: #ffffff;

    &::before {
      content: "";
      left: 50%;
      position: absolute;
      top: 6px;
      transform: translate(-50%);
      width: 36px;
      height: 6px;
      border-radius: 4px;
      background-color: #d6d6d6;
    }
  }
}
</style>
